import React from "react";

const TriggerPlayIcon = ({ size = 18, style }) => (<svg width={size} height={size} style={style} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M3.75 3.74213C3.75 3.01376 3.75 2.64958 3.90187 2.44882C4.03417 2.27393 4.23639 2.1657 4.4553 2.15263C4.70658 2.13763 5.0096 2.33964 5.61564 2.74367L13.5023 8.00145C14.0031 8.3353 14.2535 8.50222 14.3407 8.71261C14.417 8.89655 14.417 9.10328 14.3407 9.28722C14.2535 9.49761 14.0031 9.66453 13.5023 9.99837L5.61564 15.2562C5.0096 15.6602 4.70658 15.8622 4.4553 15.8472C4.23639 15.8341 4.03417 15.7259 3.90187 15.551C3.75 15.3503 3.75 14.9861 3.75 14.2577V3.74213Z"
    stroke="#2D2C44" strokeOpacity="0.7" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
</svg>
);

export default TriggerPlayIcon;

